/**
 * Reads an AWSJSON field. The shared-insights connector used to hand AppSync a string for
 * those, which arrived encoded twice, so a single parse gave back a string (BEEM-2325). Both
 * shapes are accepted, so the app works with either version of the connector deployed.
 */
export const parseAwsJson = <T>(value: unknown): T => {
  let parsed = value;
  for (let i = 0; i < 2 && typeof parsed === 'string'; i += 1) parsed = JSON.parse(parsed);
  return parsed as T;
};
